<div
  class="flex flex-col md:flex-row md:items-center px-8 md:px-16 lg:px-24 xl:px-32 gap-6 md:gap-14 lg:gap-20 xl:gap-28 md:mt-10 mb-10 md:mb-24"
  [ngClass]="{
    'flex-row-reverse': sideBySideCarouselAndTextData.rightCarousel,
  }"
>
  <div class="md:basis-1/2 shrink-0">
    @for (
      image of sideBySideCarouselAndTextData.images;
      track imgTackBy(i, image);
      let i = $index
    ) {
      @if (currentIndex() === i) {
        <ss-www-image-with-loader
          class="w-full aspect-[5/4] rounded-xl md:rounded-2xl"
          [fileDetail]="image.directus_files_id"
          desktopImageSize="half"
          [isGallery]="true"
        />
      }
    }
    <ss-www-carousel-controls
      class="block mt-4"
      [currentIndex]="currentIndex()"
      [items]="sideBySideCarouselAndTextData.images"
      (nextIndex)="currentIndex.set($event)"
    ></ss-www-carousel-controls>
  </div>
  <div
    [innerHTML]="sideBySideCarouselAndTextData.text"
    class="grow"
    [ssDirectus]="{
      collection: 'sideBySideCarouselAndText',
      item: sideBySideCarouselAndTextData.id,
      fields: ['text'],
    }"
  ></div>
</div>
